define((require) => {
    "use strict";

    const _                   = require("underscore");
    const AbstractWidgetModel = require("shared/ui/experience/widgets/AbstractWidgetModel");

    const DEFAULT_SHAPE_HEIGHT_PERCENTAGE = 40;
    const DEFAULT_SHAPE_WIDTH_PERCENTAGE = 20;
    const DEFAULT_COLOR = "#000000";
    const TYPE = "shape";

    /**
     * Model for a shape widget.
     *
     * @class ShapeWidgetModel
     * @constructor
     */
    return AbstractWidgetModel.extend("Shape widget", {

        defaults: _.defaults({
            type: TYPE,
            width: DEFAULT_SHAPE_WIDTH_PERCENTAGE,
            height: DEFAULT_SHAPE_HEIGHT_PERCENTAGE,
            borderColor: DEFAULT_COLOR,
            backgroundColor: DEFAULT_COLOR
        }, AbstractWidgetModel.prototype.defaults),

        // HACK: This line is needed for widgets supporting opacity. Remove
        // this (and the computed 'opacity' property in AbstractWidgetModel) once
        // we're comfortable... (see MOS-2375)
        computed: _.omit(AbstractWidgetModel.prototype.computed, "opacity"),

        fitToScene() {
            this.set({
                left: 0,
                top: 0,
                rotation: 0,
                width: 100,
                height: 100
            });
        },

        isValid() {
            return this.get("width") > 0 && this.get("height") > 0;
        }

    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/shapeWidget/ShapeWidgetModel.js